module.exports = __webpack_public_path__ + "static/img/brand-10.fad6e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-10.png
// module id = OJmw
// module chunks = 0